import { Routes } from '@angular/router';
import { Home } from './components/home/home';
import { RequestDetails } from './components/request-details/request-details';
import { requireLogin } from './guards/require-login.guard';

// Routes for the admin section (AI settings, skills, GitHub, reports) and the
// session-diff view are gone along with those features. Authorization guards
// are gone too: authorization is enforced server-side by the tracer, which
// scopes rows to the caller's consumer/agency — a client-side guard would only
// hide a link, not the data. requireLogin is not one of those: it only sends a
// signed-out visitor of a shared link to log in and back.

export const routes: Routes = [
  { path: '', component: Home },
  { path: 'search', component: RequestDetails, canActivate: [requireLogin] },
  { path: '**', redirectTo: '' },
];
